module.exports = __webpack_public_path__ + "static/IMG20211222153350865-a84f8ee7b3c03996dd7574b318b85df8.jpg";